<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="left-box">
				<div style="height: 330px;background: #FFFFFF;border-radius: 6px;">
					<div @click="centerDialogVisible=true" style="padding-top: 20px;padding-right: 20px;display: flex;align-items: center;cursor: pointer;">
						<div style="font-size: 12px;color: #888888;margin-left: auto;">使用LOGO模板</div>
						<img style="width: 10px;height: 10px;margin-left: 6px;" src="../../assets/order/jiantoujindian@2x.png" />
					</div>
					<div class="d-flex a-center j-center" style="height: 260px;">
						<div>
							<el-upload
							  class="avatar-uploader"
							  action="upload"
							  :show-file-list="false"
							  :on-change="getImg"
							  :http-request="()=>{}"
							  accept='.png,.jpg,.jpeg'
							  style="display: flex;justify-content: center;">
							  <div style="text-align: center;position: relative;">
								<div v-if="!user_info.logo_thumb" class="d-flex a-center j-center"
								style="position: absolute;font-size: 16px;font-weight: 700;
								color: #888888;left: 0;top: 0;bottom: 0;right: 0;">
									点击上传LOGO
								</div>
								<!-- <img style="width: 100px;height: 100px;cursor: pointer;" :src="morenLogo" /> -->
							  	<img style="width: 100px;height: 100px;cursor: pointer;" :src="user_info.logo_thumb||morenLogo" />
							  </div>
							</el-upload>
							<div style="font-size: 19px;font-weight: 700;margin-top: 20px;text-align: center;">
								{{user_info.shop_simple||user_info.company_name}}
							</div>
						</div>
					</div>
				</div>
				<div style="margin-top: 20px;height: 657px;background: #FFFFFF;border-radius: 6px;box-sizing: border-box;
				padding: 19px 26px;">
					<div class="d-flex a-center">
						<div style="font-size: 18px;font-weight: 700;">
							企业信息
						</div>
						<div @click="enterprise_info_release" style="width: 114px;height: 26px;background: #1E69FF;border-radius: 4px;margin-left: auto;
						cursor: pointer;color: #FFFFFF;font-size: 12px;text-align: center;line-height: 26px;">
							保存
						</div>
					</div>
					<div class="j-sb" style="margin-top: 30px;flex-direction: column;display: flex;height: 174px;">
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;">
							企业名称：
							<el-input v-model="user_info.company_name" style="width: 360px;margin-left: auto;" size="small" placeholder="请输入企业名称"></el-input>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;margin-top: 40px;">
							企业简称：
							<el-input v-model="user_info.shop_simple" style="width: 360px;margin-left: auto;" size="small" placeholder="请输入企业名称"></el-input>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;margin-top: 40px;">
							<div style="width: 70px;text-align: center;">宣传语/主营(选填)</div>
							<el-input v-model="user_info.shop_propagate" style="width: 360px;margin-left: auto;" size="small" placeholder="请输入企业名称"></el-input>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;margin-top: 40px;">
							企业电话：
							<el-input v-model="user_info.kf_tel" style="width: 360px;margin-left: auto;" size="small" placeholder="请输入企业电话"></el-input>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;margin-top: 40px;">
							行业分类：
							<div @click="bcState=true" style="width: 360px;height: 32px;box-sizing: border-box;border: 1px solid #DCDFE6;
							border-radius: 4px;margin-left: 18px;display: flex;align-items: center;cursor: pointer;">
								<div style="font-size: 14px;margin-left: 12px;color: #bbb;">{{selbclist.join(',')||'请选择您的行业分类'}}</div>
								<img style="width: 10px;height: 10px;margin-left: auto;margin-right: 12px;" src="../../assets/order/jiantoujindian@2x.png" />
							</div>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;margin-top: 40px;">
							企业地址：
							<div style="width: 360px;margin-left: auto;display: flex;justify-content: space-between;">
								<el-select style="width: 110px;" @change="getCity1" size="small" v-model="province1" placeholder="省/直辖市">
									<el-option
									  v-for="item in provinceList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
								<el-select style="width: 110px;" @change="getArea1" size="small" v-model="city1" placeholder="市">
									<el-option
									  v-for="item in cityList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
								<el-select @change="getOther1" style="width: 110px;" size="small" v-model="area1" placeholder="区/县">
									<el-option
									  v-for="item in areaList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;margin-top: 40px;">
							详细地址：
							<el-input v-model="user_info.shop_address" style="width: 360px;margin-left: auto;" size="small" placeholder="如xxx栋xxx号"></el-input>
						</div>
					</div>
				</div>
				<!-- <div style="margin-top: 20px;height: 310px;background: #FFFFFF;border-radius: 6px;
				box-sizing: border-box;padding: 19px 26px;">
					<div class="d-flex a-center">
						<div style="font-size: 18px;font-weight: 700;">
							企业简介(非必填)
						</div>
					</div>
					<div style="height: 230px;box-sizing: border-box;padding: 15px 0;">
						<el-input
						  type="textarea"
						  v-model="user_info.company_profile"
						  :autosize="{ minRows: 8, maxRows: 8}"
						  placeholder="请输入内容"
						  maxlength="100"
						  show-word-limit>
						</el-input>
					</div>
					<div style="font-size: 10px;color: #888888;">
						请勿使用“最”“独家”“首个”“纯天然”等字眼，请仔细阅读<span style="color: #1E69FF;">《广告法》</span>
					</div>
				</div> -->
			</div>
			<div class="right-box">
				<div class="message-admin">
					<div class="d-flex a-center">
						<div style="font-size: 18px;font-weight: 700;">
							添加分公司（如有）：
						</div>
					</div>
					<div class="j-sb" style="margin-top: 30px;flex-direction: column;display: flex;height: 185px;">
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;">
							分公司名称：
							<el-input v-model="addInfo.company_name" style="width: 460px;margin-left: auto;" size="small" 
							placeholder="请输入分公司名称"></el-input>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;">
							分公司电话：
							<el-input v-model="addInfo.company_tel" style="width: 460px;margin-left: auto;" size="small" 
							placeholder="请输入分公司电话"></el-input>
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;">
							分公司地址：
							<div style="width: 460px;margin-left: auto;display: flex;justify-content: space-between;">
								<el-select style="width: 110px;" @change="getCity" size="small" v-model="province" placeholder="省/直辖市">
									<el-option
									  v-for="item in provinceList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
								<el-select style="width: 110px;" @change="getArea" size="small" v-model="city" placeholder="市">
									<el-option
									  v-for="item in cityList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
								<el-select @change="getOther" style="width: 110px;" size="small" v-model="area" placeholder="区/县">
									<el-option
									  v-for="item in areaList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
							</div>
							
						</div>
						<div class="d-flex a-center w-100" style="font-size: 14px;color: #666;">
							详细地址：
							<el-input v-model="addInfo.address" style="width: 460px;margin-left: auto;" size="small" 
							placeholder="如xxx栋xxx号"></el-input>
						</div>
					</div>
					<div style="margin-top: 20px;display: flex;">
						<div @click="addInfo.address='';addInfo.company_name = '';addInfo.company_tel = ''" class="d-flex a-center j-center" 
						style="width: 114px;height: 26px;background: #FFFFFF;font-size: 12px;cursor: pointer;
						border: 2px solid #888888;border-radius: 4px;box-sizing: border-box;margin-left: auto;">
							清空
						</div>
						<div @click="add_branch_office" class="d-flex a-center j-center"
						style="width: 114px;height: 26px;background: #1E69FF;font-size: 12px;color: #FFFFFF;cursor: pointer;
						border: 2px solid #1E69FF;border-radius: 4px;box-sizing: border-box;margin-left: 36px;">
							添加
						</div>
					</div>
				</div>
				<div class="message-list-box">
					<div class="message-list">
						<div class="message-item-box" v-for="(item,index) in megData" :key="index">
							<div class="d-flex ac-center">
								<div style="font-size: 14px;font-weight: 700;">{{item.company_name}}</div>
								<div @click="leave_message_del(item)" class="d-flex a-center j-center"
								style="margin-left: auto;width: 60px;height: 24px;background: #000000;opacity: 0.4;
								border-radius: 6px 0px 6px 0px;cursor: pointer;">
									<img style="width: 12px;height: 12px;" src="../../assets/itemStore/scxz@2x.png" />
									<div style="font-size: 12px;color: #FFFFFF;margin-left: 4px;">删除</div>
								</div>
							</div>
							<div style="margin-top: 6px;color: #666666;font-size: 12px;">
								{{item.company_tel}}
							</div>
							<div style="margin-top: 6px;color: #666666;font-size: 13px;" class="d-flex">
								{{item.address}}
							</div>
							<div style="margin-top: 20px;border: 1px dashed #BBBBBB;"></div>
						</div>
						<div v-if="megData.length==0" class="d-flex a-center j-center">
							<img style="width: 150px;height: 150px;margin-top: 150px;" src="../../assets/Home/zwsj@2x.png" />
						</div>
					</div>
					<div style="height: 77px;" class="d-flex a-center j-center">
						<el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,15]"
							:current-page.sync="currentPage" :page-size="pageSize" layout="sizes,prev, pager, next, total,jumper" :total="total_records">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="企业LOGO设置"
		  :visible.sync="centerDialogVisible"
		  width="55%"
		  center>
		  <div class="d-flex j-center">
			  <div style="width: 728px;height: 430px;">
				<div class="d-flex a-center w-100" style="font-size: 14px;color: #000;font-weight: 700;">
					LOOG名称：
					<el-input v-model="logoInfo.text" maxlength="4" style="width: 600px;margin-left: auto;" size="small" placeholder="请输入企业名称"></el-input>
				</div>
				<div class="d-flex a-center w-100" style="font-size: 14px;height: 52px;color: #000;font-weight: 700;">
					名称颜色：
					<!-- <div style="height: 32px;width: 558px;margin-left: auto;border: 6px;" :style="'background:'+color">
					</div> -->
					<el-color-picker color-format="rgb" v-model="logoInfo.color" size="small" style="margin-left: auto;"></el-color-picker>
				</div>
				<div class="d-flex a-center w-100" style="font-size: 14px;height: 52px;color: #000;font-weight: 700;">
					LOGO模板：
				</div>
				<div class="" style="margin-top: 18px;flex-wrap: wrap;display: flex;height: 222px;">
					<div v-for="(item,index) in logoImg" :key="index" @click="setColor(item,index)"
					style="width: 80px;height: 80px;border-radius: 50%;background-size: 100% 100%;margin-left: 12px;font-weight: 700;
					margin-right: 12px;cursor: pointer;display: flex;align-items: center;justify-content: center;font-size: 12px;position: relative;" 
					:style="'background-image: url('+item.img_thumb+');color:'+logoInfo.color">
						{{logoInfo.text}}
						<div v-if="colorIndex==index" style="position: absolute;left: 0;right: 0;bottom: 0;top: 0;">
							<img style="width: 100%;height: 100%;" src="../../assets/enterprise/xuanzhong.png"/>
						</div>
					</div>
				</div>
			  </div>
			  
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="centerDialogVisible = false">取 消</el-button>
		    <el-button  size="small" type="primary" @click="img_compose">添加</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="请选择您的行业类目(可多选)"
		  :visible.sync="bcState"
		  width="55%"
		  :close-on-click-modal="false"
		  :show-close="false"
		  center>
		  <div class="d-flex" style="padding: 0 100px;">
			  <div style="width: 208px;height: 530px;overflow-y: scroll;" class="left-item">
				  <div v-for="(item,index) in bclist" @click="setOne(item,index)"
				  style="width: 90px;height: 26px;background: #FFFFFF;border-radius: 3px;margin-left: 14px;
				  box-sizing: border-box;border: 1px solid #BBBBBB;margin-top: 19px;display: inline-block;
				  text-align: center;line-height: 24px;cursor: pointer;" :style="item.is_selected == 1?'background: #1E70FF;color:#ffffff':''">
				  {{item.cat_name}}
				  </div>
			  </div>
			  <div v-if="iindex!==''" style="flex: 1;height: 530px;margin-left: 105px;" class="left-item">
				  <div v-for="(item,index) in bclist[iindex].child" 
				  :key="index" :title="item.cat_name" @click="setTwo(item)"
				  style="width: 90px;height: 26px;background: #FFFFFF;border-radius: 3px;margin-left: 14px;
				  box-sizing: border-box;border: 1px solid #BBBBBB;margin-top: 19px;display: inline-block;
				  text-align: center;line-height: 24px;cursor: pointer;text-overflow: ellipsis;overflow: hidden;"
				  :style="item.is_selected == 1?'background: #1E70FF;color:#ffffff':''">
				  {{item.cat_name}}</div>
			  </div>
			  
			  <!-- <div style="width: 802px;height: 430px;">
				<el-checkbox-group v-model="selbclist" @change="checkItem">
				    <el-checkbox v-for="(item,index) in bclist" :key="index" :label="item.cat_name" 
					style="margin-bottom: 30px;width: 82px;"></el-checkbox>
				  </el-checkbox-group>
			  </div> -->
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="bcState = false;selbclist = []">取消选择</el-button>
		    <el-button  size="small" type="primary" @click="selBcList">确定选择</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="添加新区/县"
		  :visible.sync="addressState"
		  width="25%"
		  :close-on-click-modal="false"
		  :show-close="false"
		  center>
		  <div class="d-flex j-center">
			  <el-input v-model="region_name">
				  
			  </el-input>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="addressState = false">取消</el-button>
		    <el-button  size="small" type="primary" @click="add_region_info">确定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="添加行业分类"
		  :visible.sync="categoryShow"
		  width="25%"
		  top="20vh"
		  :close-on-click-modal="false"
		  :show-close="false"
		  center>
		  <div class="d-flex j-center">
			  <el-input v-model="cat_name">
				  
			  </el-input>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="categoryShow = false">取消</el-button>
		    <el-button  size="small" type="primary" @click="add_business_category">确定</el-button>
		  </span>
		</el-dialog>
	</div>

</template>

<script>
	
	export default {

		data() {
			return{
				addressState:false,
				adstate:1,
				currentPage: 1, //初始页
				pageSize : 10,
				megData: [],
				total_records : 0,
				centerDialogVisible: false,
				addInfo:{
					company_name:'',
					address:'',
					company_tel:''
				},
				logoImg:[],
				colorIndex:0,
				iindex:'',
				logoInfo:{
					text:'',
					color:'rgba(0, 0, 0)',
					img_url:'',
				},
				provinceList:[],
				province:'',
				province1:'',
				cityList:[],
				city:'',
				city1:'',
				areaList:[],
				area:'',
				area1:'',
				user_info:JSON.parse(localStorage.getItem('user_info')),
				morenLogo:require('../../assets/staff/moren.png'),
				bclist:[],
				selbclist:[],
				selbcids:[],
				bcState:false,
				region_name:'',
				categoryShow:false,
				cat_name:'',
				classa:''
			}
		},
		methods:{
			setOne(item,index){
				this.bclist.forEach((val)=>{
					val.is_selected = 0
				})
				item.is_selected = 1
				this.iindex = index
			},
			setTwo(item){
				if(item.is_selected == 1){
					item.is_selected = 0
				}else{
					item.is_selected = 1
				}
			},
			checkItem(e){
				if(e.indexOf('其他')!==-1){
					this.categoryShow = true
					this.selbclist.splice(e.indexOf('其他'),1)
				}
			},
			add_business_category(){
				let params = {
					act:'add_business_category',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					cat_name:this.cat_name
				}
				this.$api.add_business_category(params).then((res)=>{
					if(res.code == 0){
						this.business_category_list()
						this.$message({
							showClose: false,
							message: '添加成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.categoryShow = false
				})
			},
			//selBcList
			selBcList(){
				this.bclist.forEach((item)=>{
					if(item.is_selected == 1){
						this.classa = item.cat_id
					}
				})
				this.selbcids = []
				if(this.iindex !== ''){
					this.bclist[this.iindex].child.forEach((item)=>{
						if(item.is_selected == 1){
							this.selbcids.push(item.cat_id)
						}
					})
				}
				// if(this.selbclist.length > 3){
				// 	this.$message({
				// 		showClose: false,
				// 		message: '最多之恶能选择三个行业分类',
				// 		type: 'error',
				// 		offset: 350
				// 	})
				// 	return
				// }
				this.bcState = false
				this.enterprise_info_release()
			},
			business_category_list(){
				let params = {
					act:'business_category_list_v2',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.business_category_list(params).then((res)=>{
					this.bclist = []
					this.bclist = res.data
					// this.bclist.push({cat_id: "999999",cat_name: "其他"})
					this.selbclist = []
					this.bclist.forEach((item,index)=>{
						this.user_info.shop_business_category.split(',').forEach((val)=>{
							if(item.cat_id == val){
								this.selbclist.push(item.cat_name)
							}
						})
						if(item.is_selected == 1){
							this.iindex = index
						}
					})
				})
			},
			getOther(item){
				if(item == 9999999){
					this.addressState = true
					this.adstate = 0
				}
			},
			getOther1(item){
				if(item == 9999999){
					this.addressState = true
					this.adstate = 1
				}
			},
			add_region_info(){
				this.$api.add_region_info({
					city_id:this.adstate==1?this.city1:this.city,
					region_name:this.region_name
				}).then((res)=>{
					if(res.code == 0){
						this.areaList = res.data
						res.data.forEach((item)=>{
							if(this.region_name == item.region_name){
								if(this.adstate == 1){
									this.area1 = item.region_id
								}else{
									this.area = item.region_id
								}
							}
						})
						this.addressState = false
						this.region_name = ''
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//获取省
			getProvince(){
				this.$api.getProvince({}).then((res)=>{
					if(res.code == 0){
						this.provinceList = res.data
					}
				})
			},
			//获取市区
			getCity(item){
				this.$api.getCity({province_id:item}).then((res)=>{
					this.cityList = res.data
					this.city = ''
					this.area = ''
				})
			},
			//获取区/县
			getArea(item){
				this.$api.getArea({city_id:item}).then((res)=>{
					this.areaList = []
					this.areaList = res.data
					this.areaList.push({region_id:'9999999',region_name:'其他'})
					this.area = ''
				})
			},
			//获取市区
			getCity1(item,state){
				this.$api.getCity({province_id:item}).then((res)=>{
					this.cityList = res.data
					if(state!=1){
						this.city1 = ''
						this.area1 = ''
					}
				})
			},
			//获取区/县
			getArea1(item,state){
				this.$api.getArea({city_id:item}).then((res)=>{
					this.areaList = []
					this.areaList = res.data
					this.areaList.push({region_id:'9999999',region_name:'其他'})
					if(state!=1){
						this.area1 = ''
					}
				})
			},
			//获取封面
			getImg(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.user_info.logo_thumb = res
					let params = {
						act:'upload_store_logo',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						file:res
					}
					this.$api.upload_store_logo(params).then((res)=>{
						if(res.code == 0){
							this.get_company_info() 
						}
					})
				})
			},
			//返回base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.leave_message_list()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.leave_message_list()
			},
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					localStorage.setItem('user_info', JSON.stringify(res.data))
					this.user_info = res.data
					this.province1 = this.user_info.province
					this.city1 = this.user_info.city
					if(this.province1){
						this.getCity1(this.province1,1)
					}
					this.area1 = this.user_info.district
					if(this.city1){
						this.getArea1(this.city1,1)
					}
					this.business_category_list()
				})
			},
			//添加分公司
			add_branch_office(){
				if(this.addInfo.company_name == ''){
					this.$message({
						showClose: false,
						message: '分公司名称不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.addInfo.company_tel == ''){
					this.$message({
						showClose: false,
						message: '分公司电话不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.province == ''){
					this.$message({
						showClose: false,
						message: '请选择省/直辖市',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.city == ''){
					this.$message({
						showClose: false,
						message: '请选择市',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.area == ''){
					this.$message({
						showClose: false,
						message: '请选择县/区',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.addInfo.address == ''){
					this.$message({
						showClose: false,
						message: '分公司详细地址不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				let params = {
					act:'add_branch_office',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.addInfo,
					province:this.province,
					city:this.city,
					district:this.area,
					// district:''
				}
				
				this.$api.add_branch_office(params).then((res)=>{
					if(res.code == 0){
						this.addInfo.address = ''
						this.addInfo.company_name = ''
						this.addInfo.company_tel = ''
						this.province = ''
						this.city = ''
						this.area = ''
						this.leave_message_list()
						this.$message({
							showClose: false,
							message: '添加成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//获取留言列表
			leave_message_list(){
				
				let params = {
					act:'branch_office_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:this.pageSize,
					page:this.currentPage
				}
				this.$api.branch_office_list(params).then((res)=>{
					this.megData  = []
					if(res.code == 0){
						this.megData = res.data
						this.total_records = res.total_records
					}
				})
			},
			//删除留言
			leave_message_del(item){
				let params = {
					act:'branch_office_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids:item.id
				}
				this.$api.branch_office_del(params).then((res)=>{
					if(res.code == 0){
						
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.leave_message_list()
				})
			},
			//logo 模板列表
			img_template(){
				let params = {
					act:'img_template',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type:3,
					size:99
				}
				this.$api.img_template(params).then((res)=>{
					if(res.code == 0){
						this.logoImg = res.data
						this.logoInfo.img_url = this.logoImg[0].img_url
					}
				})
			},
			setColor(item,index){
				this.colorIndex = index
				this.logoInfo.img_url = item.img_url
			},
			//logo生成
			img_compose(){
				if(this.logoInfo.text == ''){
					this.$message({
						showClose: false,
						message: 'LOGO名称不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				let arr = this.logoInfo.color.split(',')
				
				let params = {
					act:'img_compose',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.logoInfo,
					color:JSON.stringify({"r":arr[0].substring(4),"g":arr[1],"b":arr[2]})
				}
				this.$api.img_compose(params).then((res)=>{
					if(res.code == 0){
						this.get_company_info()
						this.$message({
							showClose: false,
							message: '添加成功',
							type: 'success',
							offset: 350
						})
						this.centerDialogVisible = false
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			enterprise_info_release(){
				// this.selbcids = []
				// this.bclist.forEach((item)=>{
				// 	this.selbclist.forEach((val)=>{
				// 		if(item.cat_name == val){
				// 			this.selbcids.push(item.cat_id)
				// 		}
				// 	})
				// })
				// let province = ''
				// let city = ''
				// let area = ''
				// this.provinceList.forEach((item)=>{
				// 	if(this.province1 == item.region_id){
				// 		province = item.region_name
				// 	}
				// })
				// this.cityList.forEach((item)=>{
				// 	if(this.city1 == item.region_id){
				// 		city = item.region_name
				// 	}
				// })
				// this.areaList.forEach((item)=>{
				// 	if(this.area1 == item.region_id){
				// 		area = item.region_name
				// 	}
				// })
				let params = {
					act:'enterprise_info_release',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					shop_address:this.user_info.shop_address,
					kf_tel:this.user_info.kf_tel,
					company_profile:this.user_info.company_profile,
					company_name:this.user_info.company_name,
					shop_simple:this.user_info.shop_simple,
					shop_propagate:this.user_info.shop_propagate,
					province:this.province1,
					city:this.city1,
					district:this.area1,
					// district:'',
					business_category:this.classa+':'+this.selbcids.join(',')
				}
				this.$api.enterprise_info_release(params).then((res)=>{
					if(res.code == 0){
						this.get_company_info()
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}
		},
		mounted() {
			this.getProvince()
			this.leave_message_list()
			this.img_template()
			this.get_company_info()
		}
	}
</script>

<style scoped>
	.left-item::-webkit-scrollbar{
		display: none;
	}
	.content-box{
		width: 1170px;
		min-height: 960px;
		border-radius: 6px;
		display: flex;
	}
	.tabbar-box{
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
		border-radius: 0 0 10px 10px;
		padding: 0 13px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.left-box{
		width: 500px;
		border-radius: 6px;

	}
	.left-content{
		box-sizing: border-box;
		width: 100%;
		height: 790px;
		border-radius: 14px;
		border: 10px solid #0C275E;
		margin-top: 35px;
		position: relative;
	}
	.left-top{
		width: 500px;
		height: 330px;
		background: #FFFFFF;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 38px 0px;
		position: absolute;
	}
	.qyinfo-box{
		width: 500px;
		height: 150px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 23px 20px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	.bradn-info{
		width: 500px;
		height: 310px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 24px 20px;
	}
	.service-info{
		width: 499px;
		height: 107px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 22px 20px;
	}
	.right-box{
		margin-left: 20px;
		flex: 1;
	}
	.message-admin{
		width: 100%;
		height: 330px;
		background: #FFFFFF;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 19px 26px;
	}
	.message-list-box{
		width: 100%;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
	}
	.message-list{
		height: 582px;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 0 20px;
	}
	.message-item-box{
		margin-top: 20px;
	}
	.img-box::-webkit-scrollbar{
		background: #f5f5f5;
		width: 5px;
	}
	.img-box::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #CCCCCC;
		width: 5px;
	}
	.text-hide{
		overflow:hidden;
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:1;
	}
</style>
